<template>
  <main class="z-20">
    <SectionHero />
    <SectionInfo />
    <SectionBenefits />
    <SectionStartToday />
    <SectionStartSteps />
    <SectionAffiliateProgram />
    <SectionTopExchanges />
    <SectionDownload />
    <SectionBlogs :blogList="blogList" v-if="false" />
    <SectionStartTrading />
    <SectionFAQ />
  </main>
</template>

<script setup lang="ts">
import SectionHero from "@/modules/Landing/components/Section/Hero.vue";
import SectionInfo from "@/modules/Landing/components/Section/Info.vue";
import SectionBenefits from "@/modules/Landing/components/Section/Benefits.vue";
import SectionStartToday from "@/modules/Landing/components/Section/StartToday.vue";
import SectionStartSteps from "@/modules/Landing/components/Section/StartSteps.vue";
import SectionAffiliateProgram from "@/modules/Landing/components/Section/AffiliateProgram.vue";
import SectionTopExchanges from "@/modules/Landing/components/Section/TopExchanges.vue";
import SectionDownload from "@/modules/Landing/components/Section/Download.vue";
import SectionBlogs from "@/modules/Landing/components/Section/Blogs.vue";
import SectionStartTrading from "@/modules/Landing/components/Section/StartTrading.vue";
import SectionFAQ from "@/modules/Landing/components/Section/FAQ.vue";
import apiService from "@/services/ApiService";
import { ref, onMounted } from "vue";

const blogList = ref([]);
const loading = ref(false);

const fetchBlogList = () => {
  apiService
    .get("/landing/blogs/")
    .then((res) => {
      blogList.value = res?.data?.results;
    })
    .finally(() => {
      loading.value = false;
    });
};

onMounted(() => {
  fetchBlogList();
});
</script>

<style scoped></style>
